import { Flex, Loading } from 'ui'
import { usePendingInvitesContext } from '../context/PendingInvitesProvider'
import { PendingInvitesTable } from './PendingInvitesTable'
import { Header } from './Header'
import { EmptyState } from './EmptyState'

export const PendingInvitesMain = () => {
  const {
    state: { invitesPage, isLoading, isEmpty, hasNoSearchResults },
  } = usePendingInvitesContext()

  const showLoading = isLoading && invitesPage.length === 0
  const showEmptyState = isEmpty || hasNoSearchResults

  return (
    <Flex flexDirection="column" gap={3}>
      <Header />
      {!!showLoading && <Loading />}
      {!!invitesPage.length && <PendingInvitesTable />}
      {!!showEmptyState && <EmptyState />}
    </Flex>
  )
}
